import ClusterRequirementsSnippet from "../../../../contents/docs/self-host/deploy/snippets/cluster-requirements";
import InstallingSnippet from "../../../../contents/docs/self-host/deploy/snippets/installing";
import GetInstallationAddress from "../../../../contents/docs/self-host/deploy/snippets/get-installation-address";
import UpgradingSnippet from "../../../../contents/docs/self-host/deploy/snippets/upgrading";
import UninstallingSnippet from "../../../../contents/docs/self-host/deploy/snippets/uninstalling";
import SetupDNS from "../../../../contents/docs/self-host/deploy/snippets/setup-dns";
import Disclaimer from "../../../../contents/docs/self-host/deploy/snippets/disclaimer";
import NextSteps from "../../../../contents/docs/self-host/deploy/snippets/next-steps";
import * as React from 'react';
export default {
  ClusterRequirementsSnippet,
  InstallingSnippet,
  GetInstallationAddress,
  UpgradingSnippet,
  UninstallingSnippet,
  SetupDNS,
  Disclaimer,
  NextSteps,
  React
};